import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { Login } from './Login';
import { LoginSuccess } from './LoginSuccess';
import { TermsOfUse } from './TermsOfUse';
import { PrivateRoute } from '../components/PrivateRoute';

interface Props {
  protectedApp: React.ComponentType;
}

/**
 * Top level routes for the staff app.
 *
 * @param props.protectedApp - Component rendered for every authenticated route
 */
export function StaffRootRoutes(props: Props) {
  const { protectedApp } = props;
  const location = useLocation();
  return (
    <Switch>
      {/**
       * When clicking a link that goes up a level, such as `to=".."`, the browser will append a trailing slash.
       * This breaks code like `${match.path}/flows/definitions/:id` because it ends up with a double slash.
       * The Redirect replaces the url with the same url but without the trailing slash, preserving search params.
       * https://jasonwatmore.com/post/2020/03/26/react-router-relative-links-example
       */}
      <Redirect
        from="/:url*(/+)"
        to={{
          ...location,
          pathname: location.pathname.slice(0, -1),
        }}
      />
      <Route path="/login" component={Login} />
      <Route path="/login-success" component={LoginSuccess} />
      <Route path="/terms-of-use" component={TermsOfUse} />
      <PrivateRoute path="/" component={protectedApp} />
    </Switch>
  );
}
